import { endOfMonth, format, isValid, parse, startOfMonth } from 'date-fns';

const DATE_FILTER_PATTERN = /^>=(\d{2}\/\d{2}\/\d{4})&<=(\d{2}\/\d{2}\/\d{4})$/;
const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';
const INPUT_DATE_FORMAT = 'yyyy-MM-dd';

const parseDisplayDate = (value: string) => {
  const parsedDate = parse(value, DISPLAY_DATE_FORMAT, new Date());

  return isValid(parsedDate) && format(parsedDate, DISPLAY_DATE_FORMAT) === value ? parsedDate : null;
};

export const buildDateRangeFilterValue = (fromDate: string, toDate: string) => {
  const from = parse(fromDate, INPUT_DATE_FORMAT, new Date());
  const to = parse(toDate, INPUT_DATE_FORMAT, new Date());

  if (!isValid(from) || !isValid(to)) return '';

  return `>=${format(from, DISPLAY_DATE_FORMAT)}&<=${format(to, DISPLAY_DATE_FORMAT)}`;
};

export const resolveDateRangeFilterDates = (value: string, today = new Date()) => {
  const matches = value.match(DATE_FILTER_PATTERN);

  if (matches) {
    const from = parseDisplayDate(matches[1]);
    const to = parseDisplayDate(matches[2]);

    if (from && to) {
      return {
        fromDate: format(from, INPUT_DATE_FORMAT),
        toDate: format(to, INPUT_DATE_FORMAT)
      };
    }
  }

  return {
    fromDate: format(startOfMonth(today), INPUT_DATE_FORMAT),
    toDate: format(endOfMonth(today), INPUT_DATE_FORMAT)
  };
};
